enum EnumForceLogoutType {
   IdleTimeout = 1,
   MultiLogin,
}

export default EnumForceLogoutType
